<template>
  <div v-if="visible" class="lang-switch" role="group" :aria-label="$t('header.langEn')">
    <button
      type="button"
      class="lang-btn"
      :class="{ active: locale === 'zh' }"
      @click="switchTo('zh')"
    >
      {{ $t('header.langZh') }}
    </button>
    <button
      type="button"
      class="lang-btn"
      :class="{ active: locale === 'en' }"
      @click="switchTo('en')"
    >
      {{ $t('header.langEn') }}
    </button>
  </div>
</template>

<script>
import {
  setDocumentLocale,
  stripLocalePrefix,
  withLocalePrefix,
  shouldUseLocalePrefix
} from '@/i18n/locale'
import { setArticlesLang, loadArticles } from '@/store/articles'

export default {
  name: 'LanguageSwitcher',
  computed: {
    locale() {
      return this.$i18n.locale
    },
    visible() {
      return shouldUseLocalePrefix(this.$route.path)
    }
  },
  methods: {
    async switchTo(next) {
      if (next === this.locale) return
      const bare = stripLocalePrefix(this.$route.path)
      const nextPath = withLocalePrefix(bare, next)
      setArticlesLang(next)
      setDocumentLocale(next)
      this.$i18n.locale = next
      await loadArticles(true)
      if (nextPath !== this.$route.path) {
        this.$router.push({
          path: nextPath,
          query: this.$route.query,
          hash: this.$route.hash
        }).catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lang-switch {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px;
  border-radius: 999px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

.lang-btn {
  appearance: none;
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  padding: 6px 9px;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;

  &.active {
    background: #fff;
    color: #2563eb;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
  }

  &:hover:not(.active) {
    color: #334155;
  }
}
</style>
